import { useState } from 'react'
import { SpinningLoader } from 'common-components'
import UploadIcon from 'assets/svgr-icons/Upload.svg'
import MyFilesIcon from 'assets/svgr-icons/My_Files.svg'
import CloseIcon from 'assets/svgr-icons/Close.svg'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import MediaUploadButton from 'components/MediaUploadButton'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import MobileUploadedImageView from './mobile'

import { isBlobUrl } from 'utils'
import { IMyFilesMediaItem } from 'types/media'
import { openMediaLib } from 'utils/media'
import { IReferenceMediaItem } from 'types/aiVideo'

interface ISingleUploadedImageViewProps {
  frameData: IReferenceMediaItem
  onUploadMedias: (files: File[] | FileList) => Promise<void>
  onAddMediaItemsFromMyFiles: (mediaItems: IMyFilesMediaItem[]) => void
  onRemoveImage: (id: string) => void
}
const SingleUploadedImageView: React.FC<ISingleUploadedImageViewProps> = ({
  frameData,
  onUploadMedias,
  onAddMediaItemsFromMyFiles,
  onRemoveImage
}) => {
  const { id, url, isLoading } = frameData || {}

  const isImageUploading = isLoading || isBlobUrl(url)

  const [isHovered, setIsHovered] = useState(false)
  const [isImageLoading, setIsImageLoading] = useState(true)
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const handleImageLoad = () => {
    setIsImageLoading(false)
  }

  const isImageOverlayVisible = isHovered && !isImageUploading

  const handleRemoveImage = (e?: React.MouseEvent<SVGSVGElement>) => {
    e?.stopPropagation?.()
    setIsHovered(false)
    if (id) {
      onRemoveImage(id)
    }
  }

  const onMyFilesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation?.()
    openMediaLib({
      onChoose: onAddMediaItemsFromMyFiles
    })
  }

  if (isMobile) {
    return (
      <MobileUploadedImageView
        referenceImageUrl={url}
        isUploading={isImageUploading}
        handleFilesUpload={onUploadMedias}
        onMyFilesClick={onMyFilesClick}
        handleRemoveImage={handleRemoveImage}
      />
    )
  }

  // Desktop version
  return (
    <MediaUploadButton acceptType="image" handleFilesUpload={onUploadMedias}>
      <Styled.UploadedImageContainer
        $isDragActive={false}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Styled.CloseButtonWrapper $show={isImageOverlayVisible}>
          <CloseIcon onClick={handleRemoveImage} />
        </Styled.CloseButtonWrapper>
        {url && (
          <Styled.UploadedImage
            onLoad={handleImageLoad}
            src={url}
            alt="Uploaded"
          />
        )}
        <Styled.ImageOverlay $show={isImageOverlayVisible}>
          <Styled.Button
            icon={<MyFilesIcon />}
            label={translate(T.MY_FILES_LABEL)}
            onClick={e => onMyFilesClick(e)}
          />
          <Styled.Button
            icon={<UploadIcon />}
            label={translate(T.UPLOAD_LABEL_SIDEBAR)}
          />
        </Styled.ImageOverlay>
        {(isImageUploading || isImageLoading) && (
          <Styled.LoadingOverlay>
            <SpinningLoader size={24} wrapperSize={40} loaderColor="#387DFF" />
          </Styled.LoadingOverlay>
        )}
      </Styled.UploadedImageContainer>
    </MediaUploadButton>
  )
}

export default SingleUploadedImageView
